<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord(params.id)"
    />
    <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->

    <!-- <span class="feather-icon select-none relative switch-publish">
      <vs-switch v-model="params.data.IsPublished"> -->
    <!--<span slot="on">Published</span>
        <span slot="off">Un-Published</span>-->
    <!-- </vs-switch>
    </span> -->
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  watch: {
    "params.data.IsPublished"() {
      debugger;
      //alert("watch:" + this.params.data.IsPublished);
      this.$store
        .dispatch("exhibitorManagement/updateStatus", {
          id: this.params.id,
          IsPublished: this.params.data.IsPublished,
        })
        .then(() => {
          this.showChangeStatusSuccess();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  methods: {
    // editRecord () {
    //   this.$router.push(`event/exhibitor/add/${268}`).catch(() => {})
    // },
    editRecord(id) {
      console.log("asdfasf" + id);
      this.$router
        .push({
          name: "notificationedit",
          params: {
            NotificationId: id,
          },
        })
        .catch(() => {});
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted",
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully",
      });
    },
  },
};
</script>
